<template>
  <el-dialog
    :title="`检测项明细（${config.samplename}）`"
    :visible.sync="visible"
    width="640px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClose">
    <el-table
      border=""
      :data="list">
      <el-table-column
        label="检测项"
        min-width="100"
        prop="testproject"></el-table-column>
      <el-table-column
        label="判定标准"
        min-width="140"
        prop="standnum"></el-table-column>
      <el-table-column
        min-width="60"
        label="判定值">
        <template slot-scope="{ row }">
          {{ row.symbol }}{{ row.cov }}{{ row.covunit }}
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        关 闭
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'StandardModal',
  components: { },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      list: [],
      config: {
        samplename: null
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() {
      this.list = []
    },
    getlist(cb) {
      this.loading = true
      this.$store.dispatch('account/getinspectionstandards', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.list = res.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    init(name) {
      this.config.samplename = name
      this.getlist(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
